import { ref } from "vue"
import { useToast } from "vue-toastification"


const $toast = useToast()
export const HandleErrorAxios = (error, errors = ref({})) => {
    errors.value = {}
    if (import.meta.env.SSR) {
        // console.log(error.response.status, error.response.data?.message)
        return;
    }
    // handle error from axios
    if (error.response) {


        if (error.response.data) {
            $toast.error(error.response.data.message)
        }
        if (error.response.status === 413) {
            $toast.error("File size is too large");
        }
        if (error.response.status === 422) {
            // handle validation error
            errors.value = error.response.data.errors
            return error.response.data.errors
        }
        if (error.response.status === 401) {
            // handle authentication error

            return error.response.data.message
        }
        if (error.response.status === 500) {
            // handle server error

            return error.response.data.message
        }


    }

    // handle error from vue
    if (error.message) {
        $toast.error(error.message)
        return error.message
    }

}
